<template>
  <div v-loading.fullscreen.lock="showLoading" style="padding:0;width: 100%;height: 100%">
    <div class="preview-pdf" style="margin-top: 20px;margin-left: 20px;margin-right: 20px">
      <div v-for="item in dataList" :key="item.url">
        <div :style="`margin:0 auto;width:${pdfWidth};`">
          <canvas
              v-for="page in item.pdfPages"
              :key="page"
              :id="'pdfCanvas' + item.url + page"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const PDFJS = require('pdfjs-dist')
PDFJS.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/pdf.worker.js'

export default {
  name: 'PreviewPdf',
  props: {
    pdf_urls: {
      type: Array,
      default: ''
    }
  },
  data () {
    return {
      showLoading: true,
      urls: [],
      dataList: [],
      pdfWidth: '', // 宽度
      pdfScale: 1.5 // 放大倍数
    }
  },
  mounted () {
    for (var j = 0; j < this.pdf_urls.length; j++) {
      this.getNumPages(this.pdf_urls[j], j)
    }
  },
  methods: {
    getNumPages (url, index) {
      var loadingTask = PDFJS.getDocument(url)
      loadingTask.promise.then(pdf => {
        var pdfDoc = pdf
        var item = {}
        item.pdfPages = pdf.numPages
        item.url = url
        this.dataList.push(item)
        this.$nextTick(() => {
          this.renderPage(pdfDoc, item.pdfPages, url, 1, index)
        })
      }).catch((err) => {
        this.showLoading = false
        console.error('pdf加载失败' + err)
      })
    },
    renderPage (pdfDoc, pdfPages, url, num, index) {
      const that = this
      pdfDoc.getPage(num).then(page => {
        const canvas = document.getElementById('pdfCanvas' + url + num)
        const ctx = canvas.getContext('2d')
        const dpr = window.devicePixelRatio || 1
        const bsr =
            ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio ||
            ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio ||
            ctx.backingStorePixelRatio ||
            1
        const ratio = dpr / bsr
        const viewport = page.getViewport({ scale: this.pdfScale })
        canvas.width = viewport.width * ratio
        canvas.height = viewport.height * ratio

        canvas.style.width = viewport.width + 'px'

        that.pdfWidth = viewport.width + 'px'

        canvas.style.height = viewport.height + 'px'

        ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
        // 将 PDF 页面渲染到 canvas 上下文中
        const renderContext = {
          canvasContext: ctx,
          viewport: viewport
        }
        page.render(renderContext)
        if (pdfPages > num) {
          this.renderPage(pdfDoc, pdfPages, url, num + 1, index)
        } else {
          if (index >= (this.urls.length - 1)) {
            this.showLoading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
